import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Grid2, IconButton, TextField } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { JacobBearExtraInputsForm as JacobBearExtraInputsFormType } from "../../types/forms/capture";

interface JacobBearExtraInputsFormInputsProps {
  canEdit: boolean;
}

export default function JacobBearExtraInputsFormInputs({ canEdit}: Readonly<JacobBearExtraInputsFormInputsProps>) {
  const { t } = useTranslation();
  const { register, control, formState: { errors } } = useFormContext<JacobBearExtraInputsFormType>();

  const { fields, append, remove } = useFieldArray({ control, name: "parameters" });

  return (
    <Grid2 container direction="column" spacing={2}>
      {fields.map((field, index) => (
        <Grid2 container key={field.id} spacing={2} alignItems="center">
          <Grid2 size={3.75}>
            <TextField
              label={`${t("calculations.methods.jacob-bear.gradienteHidraulico")}`}
              type="number"
              required
              disabled={!canEdit}
              {...register(`parameters.${index}.iJB`, { 
                valueAsNumber: true, 
                required: t("calculations.methods.errors.required") 
              })}
              error={!!errors.parameters?.[index]?.iJB}
              helperText={errors.parameters?.[index]?.iJB?.message}
              fullWidth
            />
          </Grid2>

          <Grid2 size={3.75}>
            <TextField
              label={`${t("calculations.methods.jacob-bear.tempCalculo")}`}
              type="number"
              required
              disabled={!canEdit}
              {...register(`parameters.${index}.tJB`, { 
                valueAsNumber: true, 
                required: t("calculations.methods.errors.required") 
              })}
              error={!!errors.parameters?.[index]?.tJB}
              helperText={errors.parameters?.[index]?.tJB?.message}
              fullWidth
            />
          </Grid2>

          <Grid2 size={3.75}>
            <TextField
              label={`${t("calculations.methods.jacob-bear.azimute")}`}
              type="number"
              required
              disabled={!canEdit}
              {...register(`parameters.${index}.gradi`, { 
                valueAsNumber: true, 
                required: t("calculations.methods.errors.required") 
              })}
              error={!!errors.parameters?.[index]?.gradi}
              helperText={errors.parameters?.[index]?.gradi?.message}
              fullWidth
            />
          </Grid2>

          {canEdit && fields.length > 1 && (
            <Grid2 size={0.65}>
              <IconButton
                aria-label="delete"
                onClick={() => remove(index)}
                color="error"
                sx={{ width: "100%" }}
              >
                <DeleteIcon />
              </IconButton>
            </Grid2>
          )}
        </Grid2>
      ))}

      {canEdit && (
        <Grid2 size={3.5}>
          <Button
            startIcon={<AddIcon />}
            onClick={() =>
              append({ iJB: undefined, tJB: undefined, gradi: undefined })
            }
            variant="outlined"
            fullWidth
          >
            {t("generic.add-row")}
          </Button>
        </Grid2>
      )}
    </Grid2>
  );
}
